module.exports = __webpack_public_path__ + "static/media/ic_download.b184b4ef.svg";